/* eslint-disable */
import {Request} from '../shared/base.requests'
import config from '../../config/customer.api'
import {appInsights} from '../shared/applicationInsights'

const aboutCompanyModule = {
  namespaced: true,
  state: {
    companyData:null,
    companyVideo:[]
  },
  mutations: {
    setCompanyData (state, payload) {
      state.companyData = payload;    
    },
    setCompanyVideo (state, payload){
      console.log(payload)
      state.companyVideo = payload;
    }
  },
  actions: {
    loadDataByCompany: function (context) { 
      return new Promise((resolve, reject) => {
        Request.get(config.getcompanyData)
        .then(response => {   
          context.commit('setCompanyData', response);          
          resolve();
        })
        .catch(error => {
          appInsights.trackException({ exception: error, message: error.message, properties: { 'apiUrl': config.getcompanyData, 'accessId': localStorage.accessId}});
          appInsights.flush();

          console.error('setCompanyData failed', error);          
          reject(error)
        })
      })
    },
    loadCompanyVideo:function (context){
      return new Promise((resolve, reject) => {        
        Request.get(config.getcompanyVideo)
        .then(response => {           
          context.commit('setCompanyVideo', response.model);
          resolve();
        })
        .catch(error => {
          appInsights.trackException({ exception: error, message: error.message, properties:  { 'apiUrl': config.getcompanyVideo, 'accessId': localStorage.accessId}});
          appInsights.flush();

          console.error('setCompanyVideo failed', error);
          reject()
        })
      })
    }
  },
  getters: {
  },   
}

export default aboutCompanyModule



// WEBPACK FOOTER //
// ./scripts/src/store/about.company.module.js